import React, { useEffect, useState } from "react";
import { Button, Popover } from "@material-ui/core";
import { differenceInDays, format, subDays } from "date-fns";
import ChevronDownIcon from "../../icons/ChevronDown";
import { DateRangePicker } from "react-date-range";
import { useTranslation } from "react-i18next";
import { pl } from "date-fns/locale";

const DateRangePickerCustom = ({ color, label }) => {
  const { t, i18n } = useTranslation();
  const date = new Date();
  const [daysCount, setDaysCount] = useState(30);
  const [selectionRange, setState] = useState([
    {
      startDate: subDays(new Date("2023-06-01"), 7),
      endDate: new Date("2023-06-01"),
      key: "selection",
    },
  ]);

  useEffect(() => {
    const diffDays = Math.abs(
      differenceInDays(selectionRange[0].endDate, selectionRange[0].startDate)
    );
    setDaysCount(diffDays);
  });

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <div>
      <Button
        aria-describedby={id}
        variant="contained"
        onClick={handleClick}
        color={color}
        endIcon={<ChevronDownIcon fontSize="small" />}
      >
        {label} {daysCount + 1} {t(`main.days`)}{" "}
        {selectionRange && selectionRange[0] && (
          <>
            ({format(selectionRange[0].startDate, "dd-MM-yyyy")} -{" "}
            {format(selectionRange[0].endDate, "dd-MM-yyyy")})
          </>
        )}
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <DateRangePicker
          locale={i18n.language != "pl" ? undefined : pl}
          staticRanges={[
            {
              label: t("other.today"),
              hasCustomRendering: false,
              range: () => ({
                startDate: date,
                endDate: date,
              }),
              isSelected() {
                return false;
              },
            },
            {
              label: t("other.last_week"),
              hasCustomRendering: false,
              range: () => ({
                startDate: subDays(date, ((date.getDay() + 7) % 7) + 6),
                endDate: subDays(date, (date.getDay() + 7) % 7),
              }),
              isSelected() {
                return false;
              },
            },
            {
              label: t("other.this_month"),
              hasCustomRendering: false,
              range: () => ({
                startDate: new Date(date.getFullYear(), date.getMonth(), 1),
                endDate: new Date(date.getFullYear(), date.getMonth() + 1, 0),
              }),
              isSelected: () => false,
            },
            {
              label: t("other.last_month"),
              hasCustomRendering: false,
              range: () => ({
                startDate: new Date(date.getFullYear(), date.getMonth() - 1, 1),
                endDate: new Date(date.getFullYear(), date.getMonth(), 0),
              }),
              isSelected() {
                return false;
              },
            },
          ]}
          months={2}
          direction="horizontal"
          ranges={selectionRange}
          showSelectionPreview={true}
          moveRangeOnFirstSelection={false}
          minDate={new Date("2022-01-01")}
          maxDate={new Date("2023-12-31")}
          onChange={(item) => setState([item.selection])}
        />
      </Popover>
    </div>
  );
};

export default DateRangePickerCustom;
